<template>
  <label :for="fieldId">
    <field-access-icon :field="field" :is-manager="isManager" />
    <span v-html="field.label ? field.label : field.title"></span>
    <span v-if="isOptional" class="optional-field">
      {{ lang.get('miscellaneous.optional') }}
    </span>
  </label>
</template>

<script>
import FieldAccessIcon from './FieldAccessIcon';

export default {
  inject: ['lang'],
  components: {
    FieldAccessIcon
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    isManager: {
      type: Boolean,
      default: false
    },
    for: {
      type: String,
      default: null
    },
    elementId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isOptional() {
      return (
        !this.field.required &&
        this.field.type !== 'content' &&
        this.field.entrantReadAccess &&
        this.field.entrantWriteAccess
      );
    },
    fieldId() {
      return this.for ? this.for : this.field.slug + '-' + this.elementId;
    }
  }
};
</script>
